/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { CREATE_ASSET,CREATE_AND_MINT_ASSET } from "../pages/CreateCollectables/graphql";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

const MODULE_NAME = "CreateAssetService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class CreateAssetService {
    private static instance: CreateAssetService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): CreateAssetService {
        if (!CreateAssetService.instance) {
            CreateAssetService.instance = new CreateAssetService(props);
        }
        return CreateAssetService.instance;
    }

    // async createAsset(formData: any) {
    //     const graphqlModule = getGraphQLModule();
    //     const client = graphqlModule.getClient("graphql-gateway");
    //     log.blue(MODULE_NAME, `data in service`, formData);
    //     try {
    //         if (client) {
    //             const res = await client.mutate({
    //                 mutation: CREATE_ASSET,
    //                 variables: {
    //                     createAssetInput: {...formData.data}
    //                 },
    //                 fetchPolicy:"no-cache"
    //             });
    //             log.success(MODULE_NAME, "getCreateAsset: ", res);
    //             return res?.data;
    //         }
    //     } catch (err) {
    //         return err
    //     }
    // }

    async createAsset(formData: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `data in service 2`, formData);
       
        try {
            if (client) {
               
                const res = await client.mutate({
                    mutation: CREATE_ASSET,
                    variables: {
                        input: {...formData}
                    },
                    fetchPolicy:"no-cache"
                });
                console.log("resyut",res)
                log.success(MODULE_NAME, "getCreateAsset: ", res);
                if(res?.data?.createAsset){
                    return res?.data;
                }
            }
          
        } catch (err) {
            return err
        }
    }

    async createAndMintAsset(formData: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `data in service`, formData);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: CREATE_AND_MINT_ASSET,
                    variables: {
                        createAndMintAssetInput: {...formData.data}
                    },
                    fetchPolicy:"no-cache"
                });
                log.success(MODULE_NAME, "getCreateAsset: ", res);
                return res?.data;
            }
        } catch (err) {
            return err;
        }
    }

    async selectAssetForm(formData: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `data in service`, formData);
        try {
            // if (client) {
            //     const res = await client.mutate({
            //         mutation: CREATE_AND_MINT_ASSET,
            //         variables: {
            //             createAndMintAssetInput: {...formData.data}
            //         },
            //         fetchPolicy:"no-cache"
            //     });
            //     log.success(MODULE_NAME, "getCreateAsset: ", res);
            //     return res?.data;
            // }
            return true
        } catch (err) {
            return err;
        }
    }



}